import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Card, CardBody } from '@patternfly/react-core';
import { useContext } from 'react';
import { CanvasFormTabsContext } from '../providers/canvas-form-tabs.provider';
export const NoFieldFound = (props) => {
    const canvasFormTabsContext = useContext(CanvasFormTabsContext);
    return (_jsx(Card, { "data-testid": "no-field-found", className: props.className, children: _jsx(CardBody, { children: _jsxs(Alert, { variant: "info", title: `No ${canvasFormTabsContext.selectedTab} fields found`, children: ["No field found matching this criteria. Please switch to the", ' ', _jsx(Button, { onClick: () => {
                            canvasFormTabsContext.setSelectedTab('All');
                        }, variant: "link", isInline: true, children: _jsx("b", { children: "All" }) }), ' ', "tab."] }) }) }));
};
//# sourceMappingURL=NoFieldFound.js.map